import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Event from "@/pages/Event";
import SubmitFilm from "@/pages/SubmitFilm";
import CreatorProfile from "@/pages/CreatorProfile";
import EditProfile from "@/pages/EditProfile";
import Browse from "@/pages/Browse";
import FilmDetail from "@/pages/FilmDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import FilmmakerTerms from "@/pages/FilmmakerTerms";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import RefundPolicy from "@/pages/RefundPolicy";
import ViewerTerms from "@/pages/ViewerTerms";
import WatchParty from "@/pages/WatchParty";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FilmmakerDashboard from "@/pages/FilmmakerDashboard";
import UploadFilm from "@/pages/UploadFilm";
import EditFilm from "@/pages/EditFilm";
import AdminDashboard from "@/pages/AdminDashboard";
import Library from "@/pages/Library";
import Watch from "@/pages/Watch";
import PaymentCallback from "@/pages/PaymentCallback";
import DonateCallback from "@/pages/DonateCallback";
import Wallet from "@/pages/Wallet";
import WalletCallback from "@/pages/WalletCallback";
import FestivalInvoiceCallback from "@/pages/FestivalInvoiceCallback";
import AIAnalyzer from "@/pages/AIAnalyzer";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/film/:id" element={<FilmDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/terms/filmmaker" element={<FilmmakerTerms />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms" element={<ViewerTerms />} />
            <Route path="/watch-party/:token" element={<WatchParty />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/event" element={<Event />} />
            <Route path="/submit-film" element={<SubmitFilm />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/donate/callback" element={<DonateCallback />} />
            <Route path="/wallet" element={
              <ProtectedRoute><Wallet /></ProtectedRoute>
            } />
            <Route path="/wallet/callback" element={
              <ProtectedRoute><WalletCallback /></ProtectedRoute>
            } />
            <Route path="/festival-invoice/callback" element={
              <ProtectedRoute roles={["filmmaker", "admin"]}><FestivalInvoiceCallback /></ProtectedRoute>
            } />

            <Route path="/library" element={
              <ProtectedRoute><Library /></ProtectedRoute>
            } />
            <Route path="/watch/:id" element={
              <ProtectedRoute><Watch /></ProtectedRoute>
            } />

            <Route path="/filmmaker" element={
              <ProtectedRoute roles={["filmmaker", "admin"]}><FilmmakerDashboard /></ProtectedRoute>
            } />
            <Route path="/filmmaker/upload" element={
              <ProtectedRoute roles={["filmmaker", "admin"]}><UploadFilm /></ProtectedRoute>
            } />
            <Route path="/filmmaker/profile" element={
              <ProtectedRoute roles={["filmmaker", "admin"]}><EditProfile /></ProtectedRoute>
            } />
            <Route path="/filmmaker/edit/:id" element={
              <ProtectedRoute roles={["filmmaker", "admin"]}><EditFilm /></ProtectedRoute>
            } />
            <Route path="/filmmaker/analyze/:id" element={
              <ProtectedRoute roles={["filmmaker", "admin"]}><AIAnalyzer /></ProtectedRoute>
            } />

            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/admin/upload" element={
              <ProtectedRoute roles={["admin"]}><UploadFilm /></ProtectedRoute>
            } />
            <Route path="/:handle" element={<CreatorProfile />} />
          </Routes>
          <Toaster richColors position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
